import { useCallback, useState } from 'react';

/**
 * A refresh counter per tab. ProfileTabs puts each tab's version in the key of its content, so
 * refreshTab remounts only that tab. refreshTab keeps one identity, so it is safe in dependency
 * lists.
 * @returns {{
 *   refreshTab: (tabId: string) => void,
 *   getTabVersion: (tabId: string) => number
 * }}
 */
export const useTabRefresh = () => {
  const [versions, setVersions] = useState({});

  const refreshTab = useCallback(
    tabId => setVersions(prev => ({ ...prev, [tabId]: (prev[tabId] ?? 0) + 1 })),
    []
  );
  const getTabVersion = tabId => versions[tabId] ?? 0;

  return { refreshTab, getTabVersion };
};
